// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Vazirmatn-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Loads the Vazirmatn font that the app uses for its UI (FONTS.regular) in the
 * browser. Imported only from index.web.tsx; the native app loads the font
 * from the bundle instead.
 */
@font-face {
  font-family: 'Vazirmatn-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
`, "",{"version":3,"sources":["webpack://./assets/fonts/index.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,gCAAgC;EAChC,+DAAsD;EACtD,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["/**\n * Loads the Vazirmatn font that the app uses for its UI (FONTS.regular) in the\n * browser. Imported only from index.web.tsx; the native app loads the font\n * from the bundle instead.\n */\n@font-face {\n  font-family: 'Vazirmatn-Regular';\n  src: url('./Vazirmatn-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
